import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import { StepMap, steps } from '../../constants';

export const pictureStepGraph: Beacon<StepMap> = {
	[steps.Picture]: [steps.BuyingDecision],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	// What ever logic is needed to determine the next step
	return steps.BuyingDecision as StepMap;
};
